import { REPORT_SENSOR_REGISTRY } from "constant/report";
import { NullableNumber, ReportItemType } from "types/Reports";

import { formatValueAndUnitBasedOnTypeInReport } from "./utils/reportFormat";

type ReportTabTotalTextProps = {
    itemType: ReportItemType;
    isValid: boolean;
    total: NullableNumber;
    textHighlightClassName: string;
    unit: string;
};

export default function ReportTabTotalText({
    itemType,
    isValid,
    total,
    textHighlightClassName,
    unit,
}: Readonly<ReportTabTotalTextProps>) {
    const totalDescriptionText = REPORT_SENSOR_REGISTRY[itemType].tabTotal;

    let usedTotal = total;

    if (!isValid) {
        usedTotal = null;
    }

    const totalCurrentDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, usedTotal, unit, false);

    return (
        <>
            <p className="ouc-total-cur-desc">{totalDescriptionText}</p>
            <p className={`ouc-total-cur ${textHighlightClassName}`}>
                {`${totalCurrentDisplay}`}
            </p>
        </>
    );
}
